/**
 * 渲染nagbar右按钮组
 */
import {supportNative, getErrorFactory, logError} from './util';

const zzc = window.zzc;


/**
 * 渲染“navbar”右侧按钮组
 * doc: https://doc.oschina.net/tantucom?t=216536
 * @export
 * @param {array} items doc文档对应的 items 属性
 * @returns Promise.resolve(true)
 */
export default function renderNavbarRightButtons(items) {
  let errorFactory = getErrorFactory('renderNavbarRightButtons');

  if (!supportNative('base_navbarRightButtons')) {
    let err = errorFactory('不支持zzcjsbridge');
    return logError(err);
  }

  zzc.call('base_navbarRightButtons', {
    items: items,
    complete: function (res) {
      if (res.state) {
        logError(errorFactory(res.message));
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/native/renderNavbarRightButtons.js